<script>
import ListDiscountsComponent from '../../features/lists/ListDiscountsComponent';
import ModalDiscountView from '../modals/ModalDiscountView';
import ModalHistoryDiscountView from '../modals/ModalHistoryDiscountView';
import ModalImportView from '../../../shared/views/ModalImportView';

export default {
  name: 'ListDiscountView',
  components: {
    'modal-discount-view': ModalDiscountView,
    'modal-history-discount-view': ModalHistoryDiscountView,
    'modal-import': ModalImportView,
  },
  extends: ListDiscountsComponent,
};
</script>

<template>
  <div class="list-body discounts-list-view">
    <!-- Toolbar de Control Original -->
    <el-row
      :gutter="20"
      class="section-ctrl"
    >
      <el-col
        :xs="24"
        :sm="8"
        :md="8"
        :lg="8"
        :xl="8"
        class="header-right"
      >
        <el-button-group class="btn-grp-drp">
          <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            :disabled="!onCanCreate(modulePermissions)"
            @click="onCreate"
          >
            Crear Descuento
          </el-button>
          <el-dropdown>
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i class="fa fa-ellipsis-v" /> <span class="hidden-xs-only">M&aacute;s Opciones</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light"
                    icon="el-icon-s-data"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onShowHistory"
                  >
                    Historial de Cupones Usados
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    icon="el-icon-upload"
                    :disabled="!onCanCreate(modulePermissions)"
                    @click="onShowImport"
                  >
                    Importar Descuentos
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onExportToExcel()"
                  >
                    <i
                      class="fa fa-file-excel-o"
                      aria-hidden="true"
                    /> Exportar
                    Excel
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> <span class="hidden-xs-only">Filtrar Por</span> <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.subscriptionPlanFilter"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Plan de Inscripción..."
                    :remote-method="onSearchSubscriptionPlans"
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.subscriptionPlanFilter ? filterOptions.subscriptionPlanFilter.id : null, 'SubscriptionPlanId')"
                  >
                    <el-option
                      v-for="item in subscriptionPlans"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="block">
                    <span class="block-title">F. Reporte:</span>
                    <el-date-picker
                      v-model="reportDate"
                      size="small"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="F. Inicio"
                      end-placeholder="F. Fin"
                      value-format="YYYY-MM-DD"
                      format="DD MMM YYYY"
                      @change="onRangeDate(reportDate, 'StartDate', 'EndDate')"
                    />
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-button-group>
      </el-col>
      <el-col
        :xs="24"
        :sm="15"
        :md="15"
        :lg="16"
        :xl="16"
        class="header-left search-inputs-row"
      >
        <el-input
          v-model="searchCode"
          size="small"
          placeholder="Buscar Codigo..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(searchCode, 'Code')"
        />
        <el-input
          v-model="searchName"
          size="small"
          placeholder="Buscar nombre..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(searchName, 'Name')"
        />
        <el-input
          v-model="searchAmount"
          size="small"
          placeholder="Cantidad ($)..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(searchAmount, 'Amount')"
        />
        <el-input
          v-model="searchMax"
          size="small"
          placeholder="Capacidad..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(searchMax, 'Max')"
        />
      </el-col>
    </el-row>

    <!-- Tabla Ligera, Limpia y Fácil de Leer -->
    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <!-- CÓDIGO -->
      <el-table-column
        label="CÓDIGO"
        min-width="150"
      >
        <template #default="scope">
          <span class="discount_code">
            {{ scope.row.code }}
          </span>
        </template>
      </el-table-column>

      <!-- NOMBRE -->
      <el-table-column
        label="NOMBRE"
        min-width="240"
      >
        <template #default="scope">
          <span class="discount_name">
            {{ scope.row.name }}
          </span>
        </template>
      </el-table-column>

      <!-- PLAN DE INSCRIPCIÓN -->
      <el-table-column
        label="PLAN DE INSCRIPCIÓN"
        min-width="220"
      >
        <template #default="scope">
          <span
            v-if="scope.row.subscriptionPlan"
            class="discount_plan_text"
          >
            {{ scope.row.subscriptionPlan }}
          </span>
          <span
            v-else
            class="discount_plan_text is-all"
          >
            Todos los planes
          </span>
        </template>
      </el-table-column>

      <!-- DESCUENTO (%) -->
      <el-table-column
        label="DESCUENTO"
        min-width="110"
        align="center"
      >
        <template #default="scope">
          <span class="discount_percent">
            {{ scope.row.amount }}%
          </span>
        </template>
      </el-table-column>

      <!-- DISPONIBILIDAD (Capacidad + Restantes en un solo vistazo) -->
      <el-table-column
        label="DISPONIBILIDAD"
        min-width="150"
        align="center"
      >
        <template #default="scope">
          <div class="discount_stock">
            <template v-if="Number(scope.row.availability) > 0">
              <span :class="Number(scope.row.availability) <= 5 ? 'stock_warning' : 'stock_available'">
                {{ scope.row.availability }}
              </span>
              <span class="stock_total"> / {{ scope.row.max }}</span>
            </template>
            <template v-else>
              <span class="stock_exhausted">Agotado</span>
              <span class="stock_total"> (0/{{ scope.row.max }})</span>
            </template>
          </div>
        </template>
      </el-table-column>

      <!-- VIGENCIA (F. Inicio → F. Conclusión) -->
      <el-table-column
        label="VIGENCIA"
        min-width="220"
        align="center"
      >
        <template #default="scope">
          <div class="discount_period">
            <span>{{ formatDate(scope.row.startDate) }}</span>
            <span class="text-muted mx-1">→</span>
            <span :class="{ 'text-danger font-weight-bold': isDiscountExpired(scope.row.endDate) }">
              {{ onCheckUpdatedAt(scope.row.endDate) ? formatDate(scope.row.endDate) : 'Sin límite' }}
            </span>
            <span
              v-if="isDiscountExpired(scope.row.endDate)"
              class="tag_expired_mini"
            >
              Vencido
            </span>
          </div>
        </template>
      </el-table-column>

      <!-- ACCIONES -->
      <el-table-column
        label="OPCIONES"
        :width="90"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown
            trigger="click"
            @command="onChangeItemOptions"
          >
            <el-button
              size="small"
              class="btn_action_trigger"
            >
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu class="discounts_action_menu">
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="fas fa-edit text-primary mr-2"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                  class="text-danger"
                >
                  <i
                    class="fas fa-trash-alt text-danger mr-2"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!-- Paginación Directa y Limpia -->
    <div class="discounts_pagination_wrap">
      <el-pagination
        v-model:current-page="currentPage"
        size="small"
        layout="prev, pager, next"
        :page-count="pagination.totalPages"
        @current-change="onPageChange"
      />
    </div>

    <!-- Modales Auxiliares -->
    <modal-discount-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
    <modal-history-discount-view
      v-if="modalHistory.isVisible"
      :conf="modalHistory"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>
